import React, { Suspense, lazy, useEffect } from 'react';
import { resolveDomainApp } from './domainApps';
import AppThemeShell from './theme/AppThemeShell';
import { ContainerContrastProvider } from './theme/localSurfaceContrastEngine';

const RuntimeUiValidationProvider = lazy(() => import('./runtimeUiValidation/RuntimeUiValidationProvider').then((module) => ({ default: module.RuntimeUiValidationProvider })));

const diagnosticsEnabled = () => process.env.NODE_ENV !== 'production'
  || window.localStorage.getItem('opengrit.uiDiagnostics') === 'true'
  || new URLSearchParams(window.location.search).has('uiDiagnostics');

const ApplicationShell = () => <main className="route-fallback" role="status" aria-busy="true" aria-label="Loading application"><div className="route-fallback__spinner" aria-hidden="true" /></main>;

const App = (props) => {
  const DomainApp = resolveDomainApp();
  useEffect(() => {
    const hydrateBackgroundPlatform = () => import('./productIntelligence/runtime').then(() => {
      window.dispatchEvent(new CustomEvent('opengrit:background-platform-ready', { detail: { label: 'Background telemetry ready' } }));
    });
    const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 5000));
    const cancelIdle = window.cancelIdleCallback || window.clearTimeout;
    const id = idle(hydrateBackgroundPlatform, { timeout: 10000 });
    return () => cancelIdle(id);
  }, []);
  const application = (
    <AppThemeShell>
      <Suspense fallback={<ApplicationShell />}><DomainApp {...props} /></Suspense>
    </AppThemeShell>
  );
  const validatedApplication = diagnosticsEnabled()
    ? <Suspense fallback={application}><RuntimeUiValidationProvider>{application}</RuntimeUiValidationProvider></Suspense>
    : application;
  // The contrast authority is the outermost visual boundary so framework and
  // diagnostics controls receive the same semantic button contract.
  return <ContainerContrastProvider>{validatedApplication}</ContainerContrastProvider>;
};

export default App;
